module.exports = __webpack_public_path__ + "img/scan.3851dcb1.svg";